import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from './../../../../environments/environment';
import { ServiceBase } from './../../../shared/service-base/ServiceBase';

@Injectable()
export class ComunicadoService extends ServiceBase {
  private baseUrlService: string;

  url: string;

  private notificacaoSubject = new BehaviorSubject<boolean>(false);
  public notificacao$ = this.notificacaoSubject.asObservable();

  private ultimoEstadoEndpoint = false;

  constructor(http: HttpClient, router: Router) {
    super(http, router);
    this.baseUrlService = environment.URL_API
  }

  private setUrlDownload(chave, tipo: string): void {
   this.url = `${this.baseUrlService}/comunicado/download/${chave}/${tipo}`;
  }

  private setUrlComunicado(): void {
    this.url = `${this.baseUrlService}/comunicado`;
  }

  private setUrlEnviarComunicado(): void {
    this.url = `${this.baseUrlService}/comunicado/upload`;
  }

  private setUrlContatos(): void {
    this.url = `${this.baseUrlService}/usuario_fabrica`;
  }

  private setUrlDealers(): void {
    this.url = `${this.baseUrlService}/filtro/dealer`;
  }

  private setUrlMarcarNaoLido(id: number) {
    this.url = `${this.baseUrlService}/comunicado/unread/${id}`;
  }

  private setUrlObterPeloId(id: number) {
    this.url = `${this.baseUrlService}/comunicado/${id}`;
  }

  private setUrlVerificarNotificacao() {
    this.url = `${this.baseUrlService}/comunicado/notificacao`;
  }

  protected getURL(): string {
    return this.url;
  }

  public buscarContatos(): Promise<any> {
    this.setUrlContatos();

    // status = 1 (ATIVO): o campo de destinatarios deve exibir apenas
    // usuarios ativos. A tela de gestao de usuarios usa o mesmo endpoint
    // sem esse filtro e continua listando ativos e inativos.
    return this.listar([], { status: 1 });
  }

  public buscarDealers(): Promise<any> {
    this.setUrlDealers();

    return this.get([]);
  }

  public buscarComunicados(filtrosAdicionais: any = {}): Promise<any> {
    this.setUrlComunicado();

    const filtros: any = {};

    if (filtrosAdicionais.dataInicio) {
      filtros.data_inicio = filtrosAdicionais.dataInicio;
    }

    if (filtrosAdicionais.dataFim) {
      filtros.data_final = filtrosAdicionais.dataFim;
    }

    if (filtrosAdicionais.assunto) {
      filtros.assunto = filtrosAdicionais.assunto;
    }

    if (filtrosAdicionais.remetente) {
      filtros.remetente = filtrosAdicionais.remetente;
    }

    // Tipo de envio: 0 = PORTAL, 1 = EMAIL, 2 = AMBOS
    if (filtrosAdicionais.tipoEnvio !== undefined && filtrosAdicionais.tipoEnvio !== null) {
      filtros.tipo_envio = filtrosAdicionais.tipoEnvio;
    }

    return this.listar([], filtros);
  }

  public marcarComoNaoLido(id: number): Promise<any> {
    this.setUrlMarcarNaoLido(id);
    return this.get([]);
  }

  public oberPeloId(id: number): Promise<any> {
    this.setUrlObterPeloId(id);
    return this.get([]);
  }

  public downloadDoArquivo(chave, tipo: string): Observable<any> {
    this.setUrlDownload(chave, tipo);

    const headers = new HttpHeaders({ 'Authorization': this.getToken() });
    const options = { headers: headers, responseType: 'blob' as const };

    return this.getHttpClient().get(this.getURL(), options);
  }

  public enviarArquivo(form: FormData): Promise<any> {
    this.setUrlEnviarComunicado();

    return this.postFormData([], form)
  }

  public verificarNotificacao(): Promise<any> {
    this.setUrlVerificarNotificacao();
    return this.get([]).then(res => {
      this.ultimoEstadoEndpoint = res.temNotificacao || false;

      this.notificacaoSubject.next(this.ultimoEstadoEndpoint);
      return res;
    });
  }

  // Método para atualizar estado baseado na lista local de comunicados
  // Combina verificação local com o último estado conhecido do endpoint
  public atualizarEstadoNotificacao(temNotificacao: boolean): void {
    // Combinar verificação local com estado do endpoint:
    // Se QUALQUER uma das fontes disser que tem notificação, mostrar badge
    const estadoFinal = temNotificacao || this.ultimoEstadoEndpoint;

    this.notificacaoSubject.next(estadoFinal);
  }

  // Método para verificar se há comunicados não lidos na lista local
  public verificarComunicadosNaoLidos(comunicados: any[]): boolean {
    return comunicados.some(comunicado => !comunicado.lido);
  }

  // Método para resetar o estado do endpoint (quando necessário)
  public resetarEstadoEndpoint(): void {
    this.ultimoEstadoEndpoint = false;
  }

}